/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum(
  "TableSortVMBehavior",
  ["BehaviorBase"],
  /**
   * Manage "sortType" & "sortColumn" & "sortSpec" attributes
   * @param {gbc} context
   * @param {classes} cls
   */
  function (context, cls) {
    /**
     * @class TableSortVMBehavior
     * @memberOf classes
     * @extends classes.BehaviorBase
     */
    cls.TableSortVMBehavior = context.oo.Singleton(cls.BehaviorBase, function ($super) {
      return /** @lends classes.TableSortVMBehavior.prototype */ {
        __name: "TableSortVMBehavior",

        watchedAttributes: {
          anchor: ["sortType", "sortColumn", "sortSpec"]
        },

        /**
         * @param {classes.ControllerBase} controller
         * @param {Object} data
         */
        setup: function (controller, data) {
          data.firstApply = true;
        },

        /**
         * @inheritDoc
         */
        _apply: function (controller, data) {
          const tableWidget = /** @type {classes.TableWidgetBase} */ controller.getWidget();

          if (tableWidget.isMultiColumnSortSupported()) {
            this._multiColumnSort(controller, data);
          } else {
            this._simpleSort(controller, data);
          }

          data.firstApply = false;
          return false;
        },

        /**
         * Simple sort
         * @param {classes.ControllerBase} controller
         * @param {*} data data to pass to the behavior
         * @private
         */
        _simpleSort(controller, data) {
          const tableWidget = /** @type {classes.RTableWidget} */ controller.getWidget();
          const tableNode = controller.getAnchorNode();

          let sortType = null;
          let sortColumn = null;

          // If stored Settings exists, send it back to VM when table is created
          const storedSortType = data.firstApply ? controller.getStoredSetting("sortType") : null;
          const storedSortColumn = data.firstApply ? controller.getStoredSetting("sortColumn") : null;

          if (storedSortType !== null && storedSortColumn !== null) {
            sortType = storedSortType;
            sortColumn = storedSortColumn;

            // Send stored sort values to VM
            const event = new cls.VMConfigureEvent(tableNode.getId(), {
              sortColumn: sortColumn,
              sortType: sortType
            });
            tableNode.getApplication().scheduler.eventVMCommand(event, tableNode);
          } else {
            sortType = tableNode.attribute("sortType");
            sortColumn = tableNode.attribute("sortColumn");
          }

          // Store the sorting configuration before applying it
          if (sortColumn === -1) {
            tableNode.getController().removeStoredSetting("sortColumn");
          } else {
            tableNode.getController().setStoredSetting("sortColumn", sortColumn);
          }

          if (sortType === "") {
            tableNode.getController().removeStoredSetting("sortType");
          } else {
            tableNode.getController().setStoredSetting("sortType", sortType);
          }

          tableWidget.setSimpleSort(sortType, sortColumn);
        },

        /**
         * Multi-column sort
         * @param {classes.ControllerBase} controller
         * @param {*} data data to pass to the behavior
         * @private
         */
        _multiColumnSort(controller, data) {
          const tableNode = /** @type {classes.TableNode} */ controller.getAnchorNode();
          const tableWidget = /** @type {classes.RTableWidget} */ controller.getWidget();

          const storedSortSpec = data.firstApply ? controller.getStoredSetting("sortSpec") : null;
          if (storedSortSpec !== null) {
            // Send stored sort values to VM
            const event = new cls.VMConfigureEvent(tableNode.getId(), {
              sortSpec: storedSortSpec
            });
            tableNode.getApplication().scheduler.eventVMCommand(event, tableNode);
          }

          const sortSpec = tableNode.attribute("sortSpec");
          if (sortSpec === "") {
            tableNode.getController().removeStoredSetting("sortSpec");
          } else {
            tableNode.getController().setStoredSetting("sortSpec", sortSpec);
          }

          const sortSpecArray = tableNode.parseSortSpec();
          tableWidget.setMultiColumnSort(sortSpecArray);
        }
      };
    });
  }
);
